import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

// Opens the emotion picker for one student. Used for students who haven't checked in yet and for students who
// already picked and want to log a new emotion later in the day.
export default function useOpenStudent() {
    const history = useHistory()
    return useCallback(
        (student) => {
            history.push(`/early/classroom/student-select-emotion?id=${student?.id}`, { student })
        },
        [history]
    )
}
